"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HamianProfile = exports.HamianConfig = void 0;
const hamianConfig_1 = __importDefault(require("./models/hamianConfig"));
exports.HamianConfig = hamianConfig_1.default;
const hamianProfile_1 = __importDefault(require("./models/hamianProfile"));
exports.HamianProfile = hamianProfile_1.default;
const storage_1 = __importDefault(require("./common/storage"));
const style_1 = __importDefault(require("./common/style"));
const service_1 = __importDefault(require("./common/service"));
const qrcode_1 = __importDefault(require("qrcode"));
class Hamian {
    constructor(appId, serverUrl, botName, useChainId, appTitle) {
        this.config = new hamianConfig_1.default({ appId, serverUrl, botName, useChainId, appTitle });
        this.createPopup();
    }
    createPopup() {
        var hamianModal = document.getElementById('hamianModal');
        if (hamianModal)
            return;
        var styleEl;
        styleEl = document.createElement('style');
        styleEl.type = 'text/css';
        styleEl.appendChild(document.createTextNode(style_1.default));
        document.head.appendChild(styleEl);
        var element = document.createElement('div');
        element.innerHTML = `
        <div id="hamianModal" class="hamain-modal" style="z-index: 99999999;"> 
        <div class="hamian-modal-container">
            <div class="hamian-close" onclick="(()=>{var modal_hamian = document.getElementById('hamianModal');modal_hamian.style.display = 'none';})()"></div>
            
            <div class="hamian-modal-content" id="hamianContent"/>
        </div>
        </div> 
        `;
        document.body.appendChild(element);
    }
    hide() {
        var modal_hamian = document.getElementById("hamianModal");
        if (modal_hamian != null)
            modal_hamian.style.display = "none";
    }
    show() {
        var modal_hamian = document.getElementById("hamianModal");
        if (modal_hamian != null)
            modal_hamian.style.display = "flex";
    }
    getprofile() {
        var profile = storage_1.default.load('profile');
        console.log('-----');
        if (profile) {
            this.profile = profile;
            return profile;
        }
        else {
            this.logout();
        }
        return null;
    }
    getRandom() {
        return Math.floor(Math.random() * 100000);
    }
    logout() {
        storage_1.default.save('profile', null);
    }
    runTransaction(walletId, transaction) {
        return new Promise((res, rej) => __awaiter(this, void 0, void 0, function* () {
            var url = this.config.serverUrl + 'api/transactionRequest';
            var profile = this.getprofile();
            if (!profile)
                return;
            var data = yield service_1.default.post(url, { walletId, transaction, token: profile.token, appTitle: this.config.appTitle });
            var actionType = '1';
            if (this.config.useChainId) {
                actionType = '3';
            }
            var link = 'tg://resolve?domain=' + this.config.botName + '&start=' + actionType + '_' + data.response.data;
            url = this.config.serverUrl + 'api/submitTransaction?appId=' + this.config.appId + '&id=' + data.response.data;
            service_1.default.getData(url)
                .then((data) => {
                this.hide();
                // res(data)
                if (data.response) {
                    res(data);
                }
                else {
                    rej({ message: data.error.message });
                }
            })
                .catch((exp) => {
                this.hide();
                var message = 'Check your internet connection';
                if (exp.message)
                    message = exp.message;
                rej({ message });
            });
            // var qr = await QRCode.toDataURL(link)
            var content = document.getElementById('hamianContent');
            // <img src="`+qr+`" style="width: 100%;" />
            if (content)
                content.innerHTML = `
            <div class="hamian-logo"></div>
            <div class="mamian-title">Confirm</div>
            <div class="mamian-description">The confirmation will send to your telegram account.</div>
            <button class="hamian-open-button" onclick="window.open('` + link + `')">
                Send Transaction For Confirmation
            </button> 
            <div id="timer">
            </div>
            `;
            this.show();
        }));
    }
    login() {
        return new Promise((res, rej) => __awaiter(this, void 0, void 0, function* () {
            var profile = storage_1.default.load('profile');
            if (profile) {
                res(profile);
                return;
            }
            var random = this.getRandom();
            var actionType = '0';
            if (this.config.useChainId) {
                actionType = '2';
            }
            var link = 'tg://resolve?domain=' + this.config.botName + '&start=' + actionType + '_' + this.config.appId + '_' + random + '_' + this.config.appTitle;
            var url = this.config.serverUrl + 'api/loginWithToken?appId=' + this.config.appId + '&random=' + random;
            service_1.default.getData(url)
                .then((data) => {
                this.hide();
                if (data.response) {
                    storage_1.default.save('profile', data.response.data);
                    res(data);
                }
                else {
                    rej({ message: data.error.message });
                }
            })
                .catch((exp) => {
                this.hide();
                var message = 'Check your internet connection';
                if (exp.message)
                    message = exp.message;
                rej({ message });
            });
            var qr = yield qrcode_1.default.toDataURL(link);
            // .then(url => {
            //     console.log('link is', url)
            // })
            // .catch(err => {
            //     console.error('error link is',err)
            // })
            var content = document.getElementById('hamianContent');
            if (content)
                content.innerHTML = `
                <div class="hamian-logo"></div>
                <div class="mamian-title">Login</div>
                <img src="` + qr + `" style="width: 100%;" />
                <button class="hamian-open-button" onclick="window.open('` + link + `')">
                    Open Hamian Bot In Telegram
                </button> 
                <div id="timer">
                </div>
                `;
            this.show();
        }));
    }
}
exports.default = Hamian;
